export default __webpack_public_path__ + "static/media/secondaryLogo.b2d8a877.png";